import { alpha } from '@mui/system';
import { themeObject } from '../../../../lib';

export const DownloadJobMenuStyles = {
    mainContainer: {
        pl: 1.5,
    },
    menu: {
        '& .MuiPaper-root': {
            width: '217px',
            borderRadius: '15px',
            boxShadow: `
             0px 3px 14px 2px ${alpha(themeObject.palette.grayScale[700], 0.12)},
             0px 8px 10px 1px ${alpha(themeObject.palette.grayScale[700], 0.14)},
             0px 3px 14px 2px ${alpha(themeObject.palette.grayScale[700], 0.2)},
            `,
            '& .MuiButtonBase-root': {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            '& .header-container': {
                paddingTop: '5px',
                position: 'relative',
                '& .MuiButtonBase-root': {
                    position: 'absolute',
                    width: '28px',
                    height: '28px',
                    top: '-5px',
                    right: '-15px',
                },
            },
        },
        transform: 'translateX(10px)',
    },
    menuItem: {
        '> .MuiTouchRipple-root': {
            backgroundColor: 'transparent',
            color: 'transparent',
        },
    },
    menuItemContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    sectionsContainer: {
        display: 'inline-flex',
        alignItems: 'baseline',
    },
    title: {
        fontFamily: 'Raleway',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '21.13px',
        color: themeObject.palette.primary[700],
    },
    messageContainer: {
        display: 'inline-flex',
        alignItems: 'baseline',
        mt: 2,
        mb: 1,
    },
    message: {
        width: '175px',
        whiteSpace: 'break-spaces',
        fontFamily: 'Red Hat Text',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '15.88px',
        letterSpacing: '0.4px',
        color: themeObject.palette.grayScale[800],
    },
};

export const DOWNLOAD_BODY_TEXT: string = 'A file can only be downloaded once.';
export const DOWNLOADED_BODY_TEXT: string = `${DOWNLOAD_BODY_TEXT} This file has already been downloaded.`;
export const DOWNLOAD_BUTTON_TEXT: string = 'DOWNLOAD';
export const DOWNLOADED_BUTTON_TEXT: string = 'DOWNLOADED';
